document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.shopify-section--main-article .rte a').forEach(function (link) {
    try {
      var linkUrl = new URL(link.href, window.location.origin);
      if (linkUrl.origin !== window.location.origin) link.setAttribute('rel', 'nofollow');
    } catch (error) {
      // Ignore malformed editorial links instead of changing their behavior.
    }
  });

  var author = document.querySelector('.article__author');
  var tocAuthors = ['By Lisa Wang', 'By Amelia Brown', 'By BrownAmelia', 'By MikeBrown'];
  var content = document.querySelector('.article__content .rte');
  if (author && content && tocAuthors.indexOf(author.textContent.trim()) !== -1) {
    var list = content.querySelector('ul');
    if (list) {
      list.replaceChildren();
      content.querySelectorAll('h2').forEach(function (heading, index) {
        var sectionId = heading.id || 'article-section-' + (index + 1);
        if (!heading.id) heading.id = sectionId;

        var link = document.createElement('a');
        link.href = '#' + sectionId;
        link.textContent = heading.textContent;
        link.addEventListener('click', function (event) {
          event.preventDefault();
          var top = heading.getBoundingClientRect().top + window.scrollY - 100;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });

        var listItem = document.createElement('li');
        listItem.append(link);
        list.append(listItem);
      });
    }
  }

  const keywords = [
    'pearl necklace', 
    'luxury jewelry', 
    'layering necklaces', 
    'earrings', 
    'jewelry trends'
  ];
  document.querySelectorAll('.article__main-part .article__content a').forEach(function (link) {
    const linkText = link.textContent.toLowerCase().trim();
    const isMatch = keywords.some(word => linkText.includes(word.toLowerCase()));
    if (isMatch) {
      var relValues = (link.getAttribute('rel') || '').split(/\s+/).filter(function (value) {
        return value && value !== 'nofollow';
      });
      if (relValues.indexOf('dofollow') === -1) relValues.push('dofollow');
      link.setAttribute('rel', relValues.join(' '));
    }
  });
});
